<template>
  <div class="storyOfChina">
    <div class="page_top">
      <a href="javascript:;" @click="goLink()" class="enter"><img src="../img/storyofchina/enter.png" alt=""></a>
    </div>
    <div class="media_wrap">
      <ul class="media_list">
        <li @click="showPlay(v.vid)" v-for="(v, i) in videoList" :key="i">
          <div class="expect" v-if="!v.vid">敬请期待</div>
          <img src="../img/storyofchina/play.png" alt="" class="play_btn">
          <img :src="v.image_url" alt="" class="item_cover" v-if="v.vid">
          <div class="item_bottom">
            <div class="item_bottom_inner">
              {{v.title}}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="copyright">版权所有 © 中文联盟</div>
    <!-- 视频播放弹框 -->
    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay">
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <!-- <ali-player
          v-if="isPlay"
          :useFlashPrism="false"
          :useH5Prism='true'
          :autoplay="true"
          :isLive="false"
          :rePlay="false"
          :showBuffer="true"
          showBarTime="5000"
          width="95%"
          height="400px"
          controlBarVisibility="always"
          :encryptType="1"
          :vid="vid"
          :playauth="auth.PlayAuth"></ali-player> -->
					<TCPlayer :options="options" style="width: 95%; height: 400px; margin: auto;" ></TCPlayer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import aliPlayer from '../pc/aliplayer'
import TCPlayer from '../pc/common/TCPlayer'

export default {
  components: {
    aliPlayer,
		TCPlayer
  },
  data: function () {
      return {
				options:{
						fileID: "",
						appID: "1500035244",
						autoplay: true,
						psign:"",
					},
        videoShow: false,
        isPlay: false,
        width: 470,
        height: 265,
        videoList: [
          {
            vid: '1397757899900028045',
            title: '第三届“用英语讲中国故事”活动启动仪式',
            image_url: require('../img/storyofchina/storyofchina.jpg')
          },
          // {
          //   vid: '',
          //   title: '嘉宾致辞',
          //   image_url: require('../img/thailand/cover_1.jpg')
          // },
          // {
          //   vid: '',
          //   title: '启动仪式',
          //   image_url: require('../img/thailand/cover_1.jpg')
          // },
          // {
          //   vid: '',
          //   title: '圆桌论坛',
          //   image_url: require('../img/thailand/cover_1.jpg')
          // }
        ],
        currentVideo: '',
        auth: {},
        vid: ''
      }
  },
  methods: {
    goLink () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i)=="micromessenger") {
        window.location.href = 'http://storyofchina.cn/'
      } else {
        window.open('http://storyofchina.cn/')
      }
    },
    closeVideo () {
      this.isPlay = false
    },
    showPlay (vid) {
      if(!vid) {
          this.$message({
            message: "敬请期待!",
            type: "warning",
          })
          return
        }
      this.vid = vid
      this.$utils.get('/subject/lesson/getvideoauth', {vid}).then(res => {
        if(res.data.success) {
          // this.auth = res.data.data
					this.options.fileID = vid;
					this.options.psign = res.data.data;
          this.isPlay = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.storyOfChina {
    width: 100%;
    // height: 100%;
    min-height: 100vh;
    background: url('../img/storyofchina/m_bg.png') no-repeat top;
    background-size: 100%;
    background-color: #a90000;
    font-family: 'Microsoft YaHei';
    overflow: hidden;
    .page_top {
      width: 100%;
      height: 7.4rem;
      position: relative;
      .enter {
        width: 4rem;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        img {
          width: 100%;
          display: block;
        }
      }
    }
    .media_wrap {
      width: 100%;
      padding: 0 .45rem;
      box-sizing: border-box;
      margin: auto;
      margin-bottom: 2.8rem;
      .media_list {
        li {
          width: calc(100% - .12rem);
          height: 6.35rem;
          background-color: #53514e;
          box-shadow: .02rem .04rem .3rem 0px 
            rgba(109, 0, 0, 0.74);
          border-style: solid;
          border-width: .06rem;
          border-image-source: linear-gradient(0deg, 
            #fdd189 0%, 
            #fab966 25%, 
            #f6a142 50%, 
            #fdd18f 100%);
          border-image-slice: 1;
          // border-radius: .05rem;
          position: relative;
          margin-bottom: .36rem;
          .play_btn {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 1.6rem;
          }
          .item_cover {
            display: block;
            width: 100%;
            height: 100%;
          }
          .item_bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
            min-height: 1rem;
            max-height: 1.5rem;
            background: url('../img/storyofchina/矩形.png') no-repeat center;
            background-size: 100%;
            font-size: .38rem;
            color: #863c2b;
            padding-top: .28rem;
            // padding-bottom: .28rem;
            padding-left: .3rem;
            padding-right: .8rem;
            line-height: 1.4;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            .item_bottom_inner {
              // padding-bottom: .28rem;
            }
          }
          .expect {
            letter-spacing: 3px;
            color: #ffefbd;
            text-shadow: 0px .1rem .14rem
              rgba(158, 6, 8, 0.51);
            font-size: .5rem;
            font-weight: bold;
            text-align: center;
            margin-top: 1.5rem;
          }
        }
      }
    }
    .copyright {
      font-size: .33rem;
      color: #f9958f;
      font-family: SourceHanSansCN-Regular;
      text-align: center;
      padding-bottom: .45rem;
    }
}
#videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
}
#videoPlayWrapper .closeVideo {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
}
.videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.videoContainer {
    text-align: center;
    width: 100%;
}
.videoContainer video {
    width: 62%;
}
video::-internal-media-controls-download-button {
    display:none;
}
video::-webkit-media-controls-enclosure {
    overflow:hidden;
}
video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
}
</style>
